import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsCtaHeroBlockHolder = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: ${colors.white};

  padding-left: ${gutterWidth / 2}px;
  padding-right: ${gutterWidth / 2}px;

  @media (min-width: ${cssBreakpoints.lgUp}) {
    padding-left: ${gutterWidth}px;
    padding-right: ${gutterWidth}px;
  }

  &[data-layout='STANDARD'] {
    padding-top: 96px;
    padding-bottom: 96px;

    @media (min-width: ${cssBreakpoints.lgUp}) {
      min-height: 440px;
    }
  }

  &[data-layout='COMPACT'] {
    padding-top: 32px;
    padding-bottom: 32px;
    margin-bottom: 32px;
    margin-top: 32px;

    @media (min-width: ${cssBreakpoints.lgUp}) {
      min-height: 170px;
    }
  }
`;

export const CmsCtaHeroBackgroundHolder = styled.div`
  position: absolute;
  transform: translateZ(0);
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const CmsCtaHeroBackgroundImageHolder = styled.div`
  width: 100%;
  height: 100%;
`;
